/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_B11Inputs */

const en_cv_extract_form_enum_b11 = /** @type {(inputs: Cv_Extract_Form_Enum_B11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B1 - Intermediate`)
};

const de_cv_extract_form_enum_b11 = /** @type {(inputs: Cv_Extract_Form_Enum_B11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B1 - Fortgeschrittene Kenntnisse`)
};

/**
* | output |
* | --- |
* | "B1 - Intermediate" |
*
* @param {Cv_Extract_Form_Enum_B11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_b11 = /** @type {((inputs?: Cv_Extract_Form_Enum_B11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_B11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_b11(inputs)
	return en_cv_extract_form_enum_b11(inputs)
});
export { cv_extract_form_enum_b11 as "cv_extract_form_enum_B1" }